module.exports = __webpack_public_path__ + "img/tastytrade-dark.ff00a949.png";